import { jsx as _jsx } from "react/jsx-runtime";
import { GOOGLE_PLAY_YPB } from 'navigation/CONSTANTS';
import { useTranslation } from 'react-i18next';
import scss from './DownloadAppLink.module.scss';
export const DownloadAppLink = () => {
    const { t } = useTranslation();
    return (_jsx("a", Object.assign({ href: GOOGLE_PLAY_YPB, target: "_blank", className: scss.downloadAppLink, rel: "noopener noreferrer" }, { children: t('useApp') })));
};
